<template>
  <b-modal
    v-model="showModal"
    ref="modalSelectUser"
    centered
    @hidden="hide"
    :hide-footer="hideFooter"
  >
    <template #modal-header>Customer List</template>
    <HeaderPanel
      title="Customer List"
      :filter="filter"
      placeholder="Search Name, Member ID, Tel, Email"
      :hasDropdown="false"
      :hasFilter="false"
      @search="handleSearch"
    />

    <div class="body">
      <b-table
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
        class="mt-2"
      >
        <template v-slot:cell(name)="data">
          <div>{{ `${data.item.firstName} ${data.item.lastName}` }}</div>
          <div class="f-12 text-light-black" v-if="data.item.externalMemberId">
            {{ data.item.externalMemberId }}
          </div>
        </template>
        <template v-slot:cell(email)="data">
          <div>{{ data.item.email || "-" }}</div>
        </template>
        <template v-slot:cell(telephone)="data">
          <div>{{ data.item.telephone || "-" }}</div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(action)="data">
          <b-button
            :disabled="checkListSelectCustomer(data.item.userId)"
            class="submit-btn"
            @click.prevent="submit(data.item)"
          >
            {{
              checkListSelectCustomer(data.item.userId) ? "Selected" : "Select"
            }}
          </b-button>
        </template>
      </b-table>
      <Pagination
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
        @handleChangeTake="handleChangeTake"
      />
    </div>

    <template #modal-footer>
      <b-row>
        <b-col class="text-left">
          <b-button @click.prevent="hide(1)" class="border-btn"
            >ยกเลิก</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="showSaveBtn">
        <b-col>
          <b-button class="submit-btn" @click.prevent="submit">บันทึก</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  components: {
    Pagination,
  },
  props: {
    hideFooter: {
      required: false,
      default: false,
      type: Boolean,
    },
    selectedCustomer: {
      required: false,
    },
    showSaveBtn: {
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      fields: [
        {
          key: "action",
                            label: "ดำเนินการ",
          class: "w-50px text-nowrap",
        },
        {
          key: "name",
          label: "ชื่อ",
        },
        {
          key: "telephone",
          label: "Telephone",
        },
        {
          key: "email",
          label: "Email",
        },
      ],
      items: [],
      isBusy: false,
      checkAll: false,
      selectAllCb: false,
      rows: 0,
      showing: 1,
      showingTo: 10,
      checkboxInactive: false,
      checkboxActive: false,
      filter: {
        search: "",
        page: 1,
        take: 5,
      },
      pageOptions: [
        { value: 5, text: "5 / หน้า" },
        { value: 10, text: "10 / หน้า" },
        { value: 20, text: "20 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
    };
  },
  watch: {
    showModal: {
      handler(value) {
        if (value) {
          this.filter = {
            search: "",
            page: 1,
            take: 5,
          };
          this.getList();
        }
      },
    },
  },
  methods: {
    checkListSelectCustomer(userId) {
      if (this.selectedCustomer && typeof this.selectedCustomer == "object")
        return this.selectedCustomer.includes(userId);
      else return userId == this.selectedCustomer;
    },
    async show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getList: async function () {
      this.isBusy = true;
      const respone = await this.$services.master.GetUserList(this.filter);
      if (respone.result === 1) {
        const { data, count } = respone.detail;
        this.items = data;
        this.rows = count;
      }
      this.isBusy = false;
    },
    handleSearch(e) {
      this.filter = {
        ...this.filter,
        ...e,
        page: 1,
      };
      this.getList();
    },
    pagination(value) {
      this.filter.page = value;
      this.getList();
    },
    handleChangeTake(take) {
      this.filter.page = 1;
      this.filter.take = take;
      this.getList();
    },

    submit(item) {
      this.$emit("select", item);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-table {
  padding: 15px;
  .header {
    text-align: right;
    margin: 10px 0px;

    .btn-export {
      width: 100px;
      background: white;
      color: black;
    }
  }

  .footer-modal {
    text-align: right;
    margin-top: 10px;
  }
}

::v-deep .modal-dialog {
  max-width: 800px;
}

::v-deep .modal-footer {
  justify-content: space-between;
}
.btn-save {
  color: #fff;
  background-color: var(--primary-color);
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}
.btn-cancel {
  color: #fff;
  background-color: #39424e;
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}
</style>
